import React, { useState } from 'react';
import { FaSearch, FaTimes, FaCheck } from 'react-icons/fa';
import { useI18n } from '../../i18n';
import MembersSelectSkeleton from './MembersSelectSkeleton';
import './MeetingMembersSelect.css';

const MeetingMembersSelect = ({
    users = [],
    selectedUserIds = [],
    onToggle,
    error = null,
    loading = false,
    placeholder = 'Search...'
}) => {
    const { t } = useI18n();
    const [searchQuery, setSearchQuery] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const selectedUsers = users.filter(u => selectedUserIds.includes(String(u.id)));
    const filteredUsers = users.filter(u =>
        u.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (u.email && u.email.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const handleToggleUser = (user) => {
        if (onToggle) {
            onToggle(String(user.id));
        }
    };

    const handleRemoveUser = (userId) => {
        if (onToggle) {
            onToggle(String(userId));
        }
    };

    const isUserSelected = (userId) => {
        return selectedUserIds.includes(String(userId));
    };

    return (
        <div className="mms-container">
            {/* Selected Users Chips Row */}
            {selectedUsers.length > 0 && (
                <div className="mms-selected-chips">
                    {selectedUsers.map(user => (
                        <div key={user.id} className="mms-chip">
                            <div className="mms-chip-content">
                                <div className="mms-chip-avatar">
                                    {user.avatar_url
                                        ? <img src={user.avatar_url} alt={user.name} />
                                        : user.name.charAt(0).toUpperCase()}
                                </div>
                                <div className="mms-chip-info">
                                    <div className="mms-chip-name">{user.name}</div>
                                </div>
                            </div>
                            <button
                                type="button"
                                className="mms-chip-remove"
                                onClick={() => handleRemoveUser(user.id)}
                                aria-label={`Remove ${user.name}`}
                            >
                                <FaTimes />
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {/* Search Input */}
            <div className="mms-search-row">
                <FaSearch className="mms-search-icon" />
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onFocus={() => setIsOpen(true)}
                    onBlur={() => setTimeout(() => setIsOpen(false), 150)}
                    placeholder={placeholder || t('common.actions.search') || 'Search...'}
                    className="mms-search-input"
                />
            </div>

            {/* User List */}
            <div className={`mms-user-list ${isOpen ? 'mms-user-list--open' : ''}`}>
                {loading ? (
                    <MembersSelectSkeleton />
                ) : filteredUsers.length === 0 ? (
                    <div className="mms-picker-empty">{t('common.empty_states.no_results') || 'No results found'}</div>
                ) : filteredUsers.map(user => (
                    <div
                        key={user.id}
                        className={`mms-picker-item ${isUserSelected(user.id) ? 'selected' : ''}`}
                        onClick={() => handleToggleUser(user)}
                    >
                        <div className="mms-picker-item-left">
                            <div className="mms-user-avatar">
                                {user.avatar_url
                                    ? <img src={user.avatar_url} alt={user.name} />
                                    : user.name.charAt(0).toUpperCase()}
                            </div>
                            <div>
                                <div className="mms-picker-item-name">{user.name}</div>
                                <div className="mms-picker-item-email">{user.email}</div>
                            </div>
                        </div>
                        {isUserSelected(user.id) && (
                            <div className="mms-picker-item-check">
                                <FaCheck />
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Error Message */}
            {error && <div className="mms-error">{error}</div>}
        </div>
    );
};

export default MeetingMembersSelect;
